export default __webpack_public_path__ + "static/media/home-bg_small.62bf7b39.jpg";